import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ExternalChannelInfoPopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "ExternalChannelInfoPopup" */ './View'),
  'popup'
);
